module.exports = __webpack_public_path__ + "img/sara.02cf38ef.png";